import { TMDRFilterType } from '@/core/modules/mdr/mdr.filters'
import { SearchFilterSection } from '@/ui/components/searchFilterSection'
import { ServiceRequestsTable } from '@components/service-requests-table'
import { MdrModule } from '@core/modules/mdr/mdr.module'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter/useUnifiedFilter'
import {
    TableTitleWrapper,
    TableWrapper,
} from '@/ui/components/CustomTable/CustomTable.styles'
import Typography from '@/ui/components/typography'
import { useMdrCasesQuery } from '@core/hooks/useMdrCasesQuery'
import MdrTableSkeleton from '@routes/mdr/components/skeleton/MdrTableSkeleton'

const ServiceRequestsPage = () => {
    const tab = 'serviceRequests'
    const filterModule = MdrModule.getFilterModuleForTab(tab)
    const { data, isLoading } = useMdrCasesQuery()

    const timeRange = MdrModule.getTimeRange()
    const allCases = data
        ? MdrModule.processCases(data, timeRange)[tab]
        : []

    const {
        data: processedData,
        search,
        handleSearchChange,
        handleFilterChange,
        handleFilterReset,
        getFilterOptions,
        filterConfig,
    } = useUnifiedFilter({
        filterModule,
        data: allCases,
    })

    if (isLoading) {
        return <MdrTableSkeleton title="MDR Service Requests" />
    }

    return (
        <TableWrapper>
            <TableTitleWrapper>
                <Typography variant="m-regular">
                    MDR Service Requests
                </Typography>
            </TableTitleWrapper>
            <SearchFilterSection
                allItems={allCases}
                filteredItems={processedData}
                searchValue={search}
                onSearchChange={handleSearchChange}
                onFilterChange={(type, options) =>
                    handleFilterChange(type as TMDRFilterType, options)
                }
                getFilterOptions={getFilterOptions}
                filterConfig={filterConfig}
                onFilterReset={handleFilterReset}
                searchPlaceholder="Search Service Requests..."
                itemLabel="Service Requests"
            />
            <ServiceRequestsTable cases={processedData} />
        </TableWrapper>
    )
}

export default ServiceRequestsPage
